import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form';
import { FiAlertTriangle, FiSave, FiSlash } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import { editSupplier, newSupplier } from '../../app/store/catalogs/thunk';
import { InputValidators } from '../../utils/InputValidators';
import Swal from 'sweetalert2';

export const M_Suppliers = ({ selectedItem, setSelectedItem, onClose }) => {

  const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();
  const dispatch = useDispatch();

  // Cuando cambia selectedItem, actualizar los campos del formulario
  useEffect(() => {
    if (selectedItem) {
      setValue("rfcProveedor", selectedItem.RFC);
      setValue("nombreProveedor", selectedItem.NAMESUPPLIER);
      setValue("webProveedor", selectedItem.WEB);
      setValue("contactProveedor", selectedItem.CONTACT);
      setValue("phoneProveedor", selectedItem.PHONE);
      setValue("emailProveedor", selectedItem.EMAIL);
      setValue("addressProveedor", selectedItem.ADDRESS);
    } else {
      reset();
    }
  }, [selectedItem, setValue, reset]);


  const save = (data) => {
    if (selectedItem) {
      Swal.fire({
        title: 'Atención',
        text: "Está por modficiar a un Proveedor, ¿Desea de continuar con esta acción?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3b7ddd',
        cancelButtonColor: '#dc3545',
        cancelButtonText: 'No',
        confirmButtonText: 'Si'
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(editSupplier(data, selectedItem.ID));
          onClose(); // cerrar modal al guardar
          reset();
        }
      })
    }
    else {
      Swal.fire({
        title: 'Atención',
        text: "Está por registar a un Proveedor, ¿Desea de continuar con esta acción?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3b7ddd',
        cancelButtonColor: '#dc3545',
        cancelButtonText: 'No',
        confirmButtonText: 'Si'
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log(data);
          dispatch(newSupplier(data));
          onClose(); // cerrar modal al guardar
          reset();
        }
      })
    }


  };

  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content" style={{ backgroundColor: '#ffffff' }}>
          <div className="modal-header">
            <h5 className="modal-title fw-bold">
              {selectedItem ? `Edición de proveedor: ${selectedItem.NAMESUPPLIER}` : "Nuevo Proveedor"}
            </h5>
            <button type="button" className="btn-close" onClick={() => { reset(); onClose(); }}></button>
          </div>

          <form onSubmit={handleSubmit(save)}>
            <div className="modal-body">
              {selectedItem && (
                <div className="alert alert-warning">
                  <strong>Atención:</strong> Está modificando la información de un proveedor.
                </div>
              )}

              <div className="mb-3">
                <label className="form-label">RFC:</label>
                <input type="text" className="form-control" autoComplete='off' {...register("rfcProveedor", { required: 'RFC es requerido', minLength: { value: 12, message: 'Debe tener mínimo 12 caracteres' } })}
                  onKeyDown={InputValidators.validateAlphanumeric} />
                {errors.rfcProveedor && (
                  <div className='text-danger fw-bold mt-1'>
                    <FiAlertTriangle size="22" /> {errors.rfcProveedor.message}
                  </div>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">Nombre:</label>
                <input type="text" className="form-control" autoComplete='off' {...register("nombreProveedor", { required: 'Nombre es requerido', minLength: { value: 2, message: 'Debe tener mínimo 2 caracteres' } })}
                  onKeyDown={InputValidators.validateAlphanumeric} />
                {errors.nombreProveedor && (
                  <div className='text-danger fw-bold mt-1'>
                    <FiAlertTriangle size="22" /> {errors.nombreProveedor.message}
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Web:</label>
                <input type="text" className="form-control" autoComplete='off' {...register("webProveedor")} />
              </div>

              <div className="mb-3">
                <label className="form-label">Contacto:</label>
                <input type="text" className="form-control" autoComplete='off' {...register("contactProveedor")} />
              </div>
              <div className="mb-3">
                <label className="form-label">Tel. Contacto:</label>
                <input type="text" className="form-control" autoComplete='off' {...register("phoneProveedor")} />
              </div>
              <div className="mb-3">
                <label className="form-label">Email:</label>
                <input type="email" className="form-control" autoComplete='off' {...register("emailProveedor")} />
              </div>
              <div className="mb-3">
                <label className="form-label">Direccion:</label>
                <textarea className="form-control" rows="3" {...register("addressProveedor")} onKeyDown={InputValidators.validateAlphanumeric}></textarea>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-outline-danger" onClick={() => { reset(); onClose(); }}>
                <FiSlash size={16} /> Cancelar
              </button>
              <button type="submit" className="btn btn-outline-primary">
                <FiSave size={16} /> Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
